module.exports = __webpack_public_path__ + "img/ring_skip_0_0_1@3x.7071352c.png";